module.exports = __webpack_public_path__ + "img/20190831135420956.d9826906.jpg";